// Utils
import { isFn } from 'utils/varValidation';

const services = [
  {
    path: 'test',
    id: 'test'
  },
  {
    path: 'rest/dealers/{webkey}/data',
    id: 'data'
  },
  {
    path: 'rest/dealers/{webkey}/settings',
    id: 'settings'
  },
  {
    path: 'rest/dealers/{webKey}/bannerSettings',
    id: 'bannerSettings'
  },
  {
    path: 'rest/dealer/{webkey}/appointment/confirm',
    id: 'confirm',
    masking: true
  },
  {
    path: 'rest/dealer/{webkey}/appointment/details',
    id: 'details'
  },
  {
    path: 'rest/dealer/{webkey}/appointment/reschedule',
    id: 'reschedule',
    masking: true
  },
  {
    path: 'rest/vehicles/dealer/{webkey}/metavehicle/details',
    id: 'metaVehicle'
  },
  {
    path: 'rest/dealer/{webkey}/appointment/getFirstAvailability',
    id: 'firstAvailable',
    masking: true
  },
  {
    path: 'rest/dealer/{webkey}/appointment/availableTimesByDates',
    id: 'availableTimes',
    masking: true
  },
  {
    path: 'rest/vehicles/dealer/{webkey}/customerVehicles',
    id: 'customerVehicles'
  },
  {
    path:
      'rest/services/dealer/{webkey}/make/{make}/model/{model}/year/{year}/recommended',
    id: 'packages'
  },
  {
    path: 'rest/vehicles/make/{make}/models',
    id: 'models'
  },
  {
    path: 'rest/vehicles/make/{make}/years',
    id: 'years'
  },
  {
    path:
      'rest/vehicles/dealer/{webkey}/make/{make}/model/{model}/year/{year}/trim',
    id: 'trims'
  },
  {
    path: 'rest/dealers/{webkey}/apptOptions',
    id: 'apptOptions'
  },
  {
    path:
      'rest/services/dealer/{webkey}/make/{make}/model/{model}/year/{year}/unscheduledservices/kind/repair',
    id: 'repair'
  },
  {
    path:
      'rest/services/dealer/{webkey}/make/{make}/model/{model}/year/{year}/unscheduledservices/kind/maintenance',
    id: 'maintenance'
  },
  {
    path: 'rest/services/dealer/{webkey}/consumer/declined',
    id: 'declined'
  },
  {
    path: 'rest/customer/autoLogin',
    id: 'autoLogin'
  },
  {
    path: 'rest/customer/login',
    id: 'login'
  },
  {
    path: '/rest/shortlink/consumer/webkey/{webkey}/token/{token}/data',
    id: 'marketing'
  },
  {
    path: 'rest/vehicles/vin/{vin}/decode',
    id: 'vin'
  },
  {
    path: 'rest/services/vehicle/{vin}/recommended',
    id: 'recalls'
  },
  {
    path: 'rest/dealer/{webkey}/appointment/{reservationId}/cancel',
    id: 'cancel'
  },
  {
    path: 'rest/customer/lostUserName',
    id: 'lostUserName'
  },
  {
    path: 'rest/customer/lostPassword',
    id: 'lostPassword'
  },
  {
    path: 'rest/customer/new',
    id: 'signUp'
  },
  {
    path: 'rest/customer/vehicle/{vehicleId}/disable',
    id: 'deleteVehicle'
  },
  {
    path: 'rest/customer/update',
    id: 'update'
  },
  {
    path: 'rest/promotions/dealer/{webkey}/customer/{extId}/vin/{vin}',
    id: 'promotions'
  },
  {
    path: 'rest/promotions/dealer/{webkey}/getAnonymousPromotionForDealer',
    id: 'anonymousPromotion'
  },
  {
    path: 'rest/dealers/{webkey}/saveStats',
    id: 'saveStats'
  },
  {
    path: 'rest/customer/changePassword',
    id: 'changePassword'
  },
  {
    path: 'rest/customer/disable',
    id: 'deleteAccount'
  },
  {
    path: 'rest/country/{countryCode}/states',
    id: 'states'
  },
  {
    path: 'rest/customer/verify',
    id: 'verify'
  },
  {
    path: 'rest/statustracker/appointment/{reservationId}/details',
    id: 'statusTracker'
  },
  {
    path: 'rest/dealer/{webkey}/details',
    id: 'selfCheckIn'
  },
  {
    path: 'rest/dealer/{webkey}/checkin',
    id: 'checkIn'
  },
  {
    path: 'rest/customer/getCustomerMktSMSOptInPref/{webKey}/{personId}',
    id: 'optStatus'
  },
  {
    path:
      'rest/customer/optOutCustomerForSMSMarketing/{webKey}/{personId}/{application}',
    id: 'optOutCustomerForSMSMarketing'
  },
  {
    path: 'rest/customer/optinurl',
    id: 'optInUrl'
  },
  {
    path: 'rest/vehicles/dealer/{webkey}/chromeid/{chromeId}',
    id: 'vehicleByChromeStyleId'
  },
  {
    path: 'rest/customer/preferences/{webKey}/{personId}',
    id: 'customerPreferences'
  },
  {
    path:
      'rest/customer/{personId}/dealer/{webKey}/preference/{notificationType}/{action}',
    id: 'statusChangePreference'
  },
  {
    path: 'rest/dealer/{webkey}/quote/{quoteConfirmationId}/details',
    id: 'quotingDetails'
  }
];

const ServiceClass = function(service, dispatch) {
  this.id = service.id;
  this.path = service.path;
  this.pathVars = service.pathVars || {};
  this.masking = service.masking || false;
  this.getPath = () => {
    const properties = Object.getOwnPropertyNames(this.pathVars);
    let newPath = this.path;
    let i = 0;
    for (i; i < properties.length; i++) {
      newPath = newPath.replace(
        new RegExp(`{${properties[i]}}`),
        encodeURIComponent(this.pathVars[properties[i]])
      );
    }
    return newPath;
  };
  this.getPathVars = () => {
    return this.pathVars;
  };
  this.setPathVars = pathVars => {
    this.pathVars = pathVars;
  };
  this.requestCallback = () => {};
  this.responseCallback = () => {};
  this.setMasking = masking => {
    this.masking = masking;
  };
  this.getMasking = () => {
    return this.masking;
  };
  this.getId = () => {
    return this.id;
  };
  this.setCallBacks = callBacks => {
    if (isFn(callBacks.request)) {
      this.requestCallback = callBacks.request;
    }
    if (isFn(callBacks.response)) {
      this.responseCallback = callBacks.response;
    }
  };
};

export const getService = id => {
  const found = services.find(service => service.id === id);
  return new ServiceClass(found);
};



// WEBPACK FOOTER //
// ./src/constants/ajax.js